import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { FeedInsertSettings } from "../../content.types";
import { requestFeedInsertsSettings } from "./feedInsertsSettings.request";

const useFeedInsertsSettings = (
  options?: QueryOptions<FeedInsertSettings, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["feed-inserts-settings"],
    queryFn: requestFeedInsertsSettings,
    ...options
  });

  return { feedInsertsSettings: data, ...rest };
};

export default useFeedInsertsSettings;
